<template>
  <v-row
    align="center"
    justify="start"
    no-gutters
  >
    <v-col
      cols="2"
      sm="3"
      md="6"
      lg="4"
      xl="2"
      class="pa-1"
      v-for="source in params.value"
      :key="source"
    >
      <v-img
        contain
        :source="source"
        :src="targetImage(source)"
        aspect-ratio="1"
      ></v-img>
    </v-col>
  </v-row>
</template>

<script>
  import { TARGET_TYPE } from '@/appLogic/targets/Constants'
  import AMRLD from '@/assets/dataSources/AMRLD-Selected.png'
  import MRI from '@/assets/dataSources/MRI-Selected.png'
  import NCS from '@/assets/dataSources/Ncs-Selected.png'
  import EpsilonImg from '@/assets/dataSources/Epsilon-Selected.png'
  import AudienceMattersTarget from '@/assets/targetImages/Audience_Matters_Target.png'
  import Xandr from '@/assets/targetImages/XandrIcon.png'
  import AdstraImg from '@/assets/targetImages/AdstraIcon.png'
  import PIDTargetImg from '@/assets/fileTypes/PID-Selected.png'
  import NPowerImg from '@/assets/fileTypes/NPower-Selected.png'
  import ComscoreImg from '@/assets/fileTypes/Comscore-Selected.png'
  import PrismImg from '@/assets/dataSources/Prism-Selected.png'
  import BYODImg from '@/assets/dataSources/BYOD-Selected.png'
  import DNBImg from '@/assets/dataSources/DNB-Selected.png'
  import MaxImg from '@/assets/dataSources/Max-Selected.png'
  import VideoampImg from '@/assets/dataSources/Videoamp-Selected.png'
  import TVEImg from '@/assets/dataSources/TVE-Selected.png'
  import DiscoveryPlusImg from '@/assets/dataSources/DiscoveryPlus-Selected.png'
  import DCRImg from '@/assets/dataSources/DCR-Selected.png'
  import DCComicsImg from '@/assets/dataSources/DC_Comics-Selected.png'
  import LiveRampImg from '@/assets/dataSources/LiveRamp-Selected.png'
  import WBGamesImg from '@/assets/dataSources/WBGames-Selected.png'
  import RetargetingImg from '@/assets/dataSources/Retargeting-Selected.png'
  import FreeWheelImg from '@/assets/destinations/Freewheel-Selected.png'
  import GoogleAdManagerImg from '@/assets/destinations/GAM-Selected.png'
  import LALImg from '@/assets/dataSources/LAL_Selected.png'
  import CNNImg from '@/assets/dataSources/CNN-Selected.png'
  import MosaicImg from '@/assets/dataSources/Mosaic-Selected.png'

  export default {
    computed: {
      nielsenDatasources() {
        return this.$parent.$parent.nielsenDatasources
      },
      C360Datasources() {
        return this.$parent.$parent.C360Datasources
      },
    },
    methods: {
      targetImage(source) {
        const imageMap = {
          [this.nielsenDatasources.AMRLD]: AMRLD,
          [this.nielsenDatasources.MRI]: MRI,
          [this.nielsenDatasources.NCS]: NCS,
          [this.C360Datasources.EPSILON]: EpsilonImg,
          [this.nielsenDatasources.COMSCORE_TV]: ComscoreImg,
          [this.nielsenDatasources.NIELSEN]: NPowerImg,
          [this.nielsenDatasources.PID]: PIDTargetImg,
          [this.nielsenDatasources.COMSCORE]: ComscoreImg,
          [this.C360Datasources.XANDR]: Xandr,
          [this.nielsenDatasources.FILE]: Xandr,
          [this.C360Datasources.ADSTRA]: AdstraImg,
          [this.C360Datasources.PRISM]: PrismImg,
          [this.C360Datasources.BYOD]: BYODImg,
          [this.C360Datasources.DNB]: DNBImg,
          [this.C360Datasources.MAX]: MaxImg,
          [this.C360Datasources.VIDEOAMP]: VideoampImg,
          [this.C360Datasources.TVE]: TVEImg,
          [this.C360Datasources.DISCOVERY_PLUS]: DiscoveryPlusImg,
          [this.C360Datasources.DCR]: DCRImg,
          [this.C360Datasources.DC_COMICS]: DCComicsImg,
          [this.C360Datasources.LIVERAMP]: LiveRampImg,
          [this.C360Datasources.WBGAMES]: WBGamesImg,
          [this.C360Datasources.RETARGETING]: RetargetingImg,
          [this.C360Datasources.FREEWHEEL]: FreeWheelImg,
          [this.C360Datasources.GOOGLE_AD_MANAGER]: GoogleAdManagerImg,
          [this.C360Datasources.LAL]: LALImg,
          [this.C360Datasources.CNN]: CNNImg,
          [this.C360Datasources.MOSAIC]: MosaicImg,
        }

        if (this.params.value === TARGET_TYPE.XANDR_SEGMENT) {
          return Xandr
        }

        return imageMap[source] || AudienceMattersTarget
      },
    },
  }
</script>

<style></style>



// WEBPACK FOOTER //
// TargetRenderer.vue?709d539e